import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BasefieldV2Component } from '../basefield-v2/basefield-v2.component';

@Component({
  selector: 'card-expiration-v2',
  templateUrl: './card-expiration-v2.component.html',
  styleUrls: ['./card-expiration-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardExpirationV2Component extends BasefieldV2Component {}
